import React, { useId } from "react";
import { ArrowRightIcon } from "lucide-react";
import { offer } from "../data/offer";
import { ctaClasses } from "../utils/cta";
type PurchaseButtonProps = {
  label: string;
  className?: string;
};

// Final purchase buttons: go to checkout when offer.checkoutUrl is set.
export function PurchaseButton({
  label,
  className = ""
}: PurchaseButtonProps) {
  const noteId = useId();
  const isReady = offer.checkoutUrl.trim().length > 0;
  const content = <>
      <span data-id="element-248" data-mp="vp26lgz818z2">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" strokeWidth={2.75} aria-hidden="true" data-id="element-249" data-mp="vpbmucugs1rk" />
    </>;
  if (isReady) {
    return <a href={offer.checkoutUrl} data-cta="checkout" className={`${ctaClasses} ${className}`} data-id="element-250" data-mp="lyqpstufv5ar">
        {content}
      </a>;
  }
  return <div className={className} data-id="element-251" data-mp="19o1ng2ghsjko">
      <button type="button" disabled aria-describedby={noteId} className={`${ctaClasses} cursor-not-allowed opacity-60`} data-id="element-252" data-mp="19n099p46jgyq">
        {content}
      </button>
      <p id={noteId} className="mt-2 text-center text-xs font-medium text-ink-soft" data-id="element-253" data-mp="ry7a3hhclccc">
        Checkout opens very soon.
      </p>
    </div>;
}